import { Plan, ePlanType } from "../../../../@types/Billing/Plan";
import { PiPlanetThin } from "react-icons/pi";
import { IoPlanetOutline, IoPlanetSharp } from "react-icons/io5";

const netunoIcon = {
  element: <PiPlanetThin size={45} color="#7992CB" />,
};
const netunoFeatures = [
  //Bronze
  "Acesso completo a todos ativos",
  "Siga até 60 ativos",
  "Até 120 análises por mês",
  "Até 40 análises de carteira por mês",
  "Até 30 ativos na carteira",
  "Receba todas atualizações de IA",
];

const saturnoIcon = {
  element: <IoPlanetOutline size={45} color="#DEB07F" />,
};
const saturnoFeatures = [
  //Prata
  "Acesso completo a todos ativos",
  "Siga até 120 ativos",
  "Até 240 análises por mês",
  "Até 100 análises de carteira por mês",
  "Até 60 ativos na carteira",
  "Receba atualizações de IA rapidamente",
];

const jupiterIcon = {
  element: <IoPlanetSharp size={45} color="#D4BDAB" />,
};
const jupiterFeatures = [
  //Ouro
  "Acesso completo a todos ativos",
  "Siga até 240 ativos",
  "Até 600 análises por mês",
  "Até 240 análises de carteira por mês",
  "Até 120 ativos na carteira",
  "Receba atualizações de IA prioritária",
];

export const availablePlans: Plan[] = [
  {
    title: "Netuno",
    identifier: "bronze_mensal",
    price: "59,90",
    type: ePlanType.MONTHLY,
    icon: netunoIcon,
    features: netunoFeatures,
    canTrial: false,
  },
  {
    title: "Netuno",
    identifier: "bronze_anual",
    price: "499,90",
    type: ePlanType.ANNUALY,
    icon: netunoIcon,
    features: netunoFeatures,
    canTrial: false,
  },
  {
    title: "Saturno",
    identifier: "prata_mensal",
    price: "129,90",
    type: ePlanType.MONTHLY,
    icon: saturnoIcon,
    features: saturnoFeatures,
    canTrial: false,
  },
  {
    title: "Saturno",
    identifier: "prata_anual",
    price: "999,90",
    type: ePlanType.ANNUALY,
    icon: saturnoIcon,
    features: saturnoFeatures,
    canTrial: false,
  },
  {
    title: "Júpiter",
    identifier: "ouro_mensal",
    price: "299,90",
    type: ePlanType.MONTHLY,
    icon: jupiterIcon,
    features: jupiterFeatures,
    canTrial: false,
  },
  {
    title: "Júpiter",
    identifier: "ouro_anual",
    price: "1.999,90",
    type: ePlanType.ANNUALY,
    icon: jupiterIcon,
    features: jupiterFeatures,
    canTrial: false,
  },
];
